import { Component, OnInit } from "@angular/core";
import { UserManagementService } from "../../core/services/user-management.service";
import { GenericResponseDto } from "../../core/models/generic-response.dto";
import { ValidateLogin } from "../../core/models/validate-login.dto";
import { UserRole } from "../../shared/enums/userRoles.enum";
import { InvoiceReviewListingPaginatedComponent } from "./invoice-review-listing-paginated/invoice-review-listing-paginated.component";

@Component({
  selector: "jni-invoice-review",
  templateUrl: "./invoice-review.component.html",
  styleUrls: ["./invoice-review.component.scss"],
  imports: [InvoiceReviewListingPaginatedComponent],
})
export class InvoiceReviewComponent implements OnInit {
  userRole = 0;

  invoicePreviewAdminStatus = false;

  constructor(private _loginService: UserManagementService) {}

  ngOnInit(): void {
    this.getUserRole();
  }

  getUserRole() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe((res: GenericResponseDto<ValidateLogin>) => {
        this.userRole = res.data.userRoleId;
        if (this.userRole === UserRole.Admin) {
          this.invoicePreviewAdminStatus = true;
        }
      });
  }
}
